import React from 'react';

export const sparkleSVG = (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_842_26935)">
      <path
        d="M12.9996 9C13.0009 9.20386 12.9389 9.40311 12.8223 9.57033C12.7057 9.73754 12.5401 9.86451 12.3484 9.93375L9.12461 11.125L7.93711 14.3512C7.86679 14.5423 7.73956 14.7072 7.57259 14.8236C7.40561 14.9401 7.20694 15.0025 7.00336 15.0025C6.79979 15.0025 6.60111 14.9401 6.43414 14.8236C6.26716 14.7072 6.13993 14.5423 6.06961 14.3512L4.87461 11.125L1.64836 9.9375C1.45732 9.86718 1.29244 9.73995 1.17598 9.57298C1.05951 9.406 0.99707 9.20733 0.99707 9.00375C0.99707 8.80017 1.05951 8.6015 1.17598 8.43452C1.29244 8.26755 1.45732 8.14032 1.64836 8.07L4.87461 6.875L6.06211 3.64875C6.13243 3.45771 6.25966 3.29283 6.42664 3.17637C6.59361 3.0599 6.79229 2.99746 6.99586 2.99746C7.19944 2.99746 7.39811 3.0599 7.56509 3.17637C7.73206 3.29283 7.85929 3.45771 7.92961 3.64875L9.12461 6.875L12.3509 8.0625C12.5427 8.13237 12.7082 8.26008 12.8244 8.42801C12.9406 8.59594 13.0018 8.7958 12.9996 9ZM9.49961 3H10.4996V4C10.4996 4.13261 10.5523 4.25979 10.6461 4.35355C10.7398 4.44732 10.867 4.5 10.9996 4.5C11.1322 4.5 11.2594 4.44732 11.3532 4.35355C11.4469 4.25979 11.4996 4.13261 11.4996 4V3H12.4996C12.6322 3 12.7594 2.94732 12.8532 2.85355C12.9469 2.75979 12.9996 2.63261 12.9996 2.5C12.9996 2.36739 12.9469 2.24021 12.8532 2.14645C12.7594 2.05268 12.6322 2 12.4996 2H11.4996V1C11.4996 0.867392 11.4469 0.740215 11.3532 0.646447C11.2594 0.552678 11.1322 0.5 10.9996 0.5C10.867 0.5 10.7398 0.552678 10.6461 0.646447C10.5523 0.740215 10.4996 0.867392 10.4996 1V2H9.49961C9.367 2 9.23983 2.05268 9.14606 2.14645C9.05229 2.24021 8.99961 2.36739 8.99961 2.5C8.99961 2.63261 9.05229 2.75979 9.14606 2.85355C9.23983 2.94732 9.367 3 9.49961 3ZM14.9996 5H14.4996V4.5C14.4996 4.36739 14.4469 4.24021 14.3532 4.14645C14.2594 4.05268 14.1322 4 13.9996 4C13.867 4 13.7398 4.05268 13.6461 4.14645C13.5523 4.24021 13.4996 4.36739 13.4996 4.5V5H12.9996C12.867 5 12.7398 5.05268 12.6461 5.14645C12.5523 5.24021 12.4996 5.36739 12.4996 5.5C12.4996 5.63261 12.5523 5.75979 12.6461 5.85355C12.7398 5.94732 12.867 6 12.9996 6H13.4996V6.5C13.4996 6.63261 13.5523 6.75979 13.6461 6.85355C13.7398 6.94732 13.867 7 13.9996 7C14.1322 7 14.2594 6.94732 14.3532 6.85355C14.4469 6.75979 14.4996 6.63261 14.4996 6.5V6H14.9996C15.1322 6 15.2594 5.94732 15.3532 5.85355C15.4469 5.75979 15.4996 5.63261 15.4996 5.5C15.4996 5.36739 15.4469 5.24021 15.3532 5.14645C15.2594 5.05268 15.1322 5 14.9996 5Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_842_26935">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const padlockSVG = (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.5 7.5H3.5C2.94772 7.5 2.5 7.94772 2.5 8.5V13.5C2.5 14.0523 2.94772 14.5 3.5 14.5H12.5C13.0523 14.5 13.5 14.0523 13.5 13.5V8.5C13.5 7.94772 13.0523 7.5 12.5 7.5Z"
      stroke="#585E72"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5 7.5V4.5C5 3.70435 5.31607 2.94129 5.87868 2.37868C6.44129 1.81607 7.20435 1.5 8 1.5C8.79565 1.5 9.55871 1.81607 10.1213 2.37868C10.6839 2.94129 11 3.70435 11 4.5V7.5"
      stroke="#585E72"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
